import { render, staticRenderFns } from "./UploaderCard.vue?vue&type=template&id=c55083c2"
import script from "./UploaderCard.vue?vue&type=script&lang=js"
export * from "./UploaderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports